import { ImageResizeOptions, WowImage } from '@wix/wix-ui-tpa/cssVars';
import { useExperiments } from '@wix/yoshi-flow-editor';
import type { FC } from 'react';
import React from 'react';

import type { BlogPost } from '../../../../../../../types';
import { Experiment } from '../../../../../../../types';
import { classes, st } from './Cover.st.css';
import { useCover } from './hooks';

type PostCoverProps = Pick<BlogPost, 'media'>;

export const Cover: FC<PostCoverProps> = ({ media }) => {
  const { url, width, height, aspectRatio } = useCover(media);
  const { experiments } = useExperiments();

  const useNewPostsCoverDefaults = experiments.enabled(
    Experiment.UseNewPostsCoverDefaults,
  );

  // Since WoWImage contains static width and height style params,
  // this CSS var is needed to force container resize when switching from
  // fixed to image-specific aspect ratio

  const containerStyle = {
    '--containerAspectRatio': aspectRatio,
  } as React.CSSProperties;

  return (
    <div
      style={containerStyle}
      className={st(classes.root, {
        oldDefaults: !useNewPostsCoverDefaults,
        newDefaults: useNewPostsCoverDefaults,
      })}
    >
      <WowImage
        className={classes.image}
        src={url}
        sourceWidth={width}
        sourceHeight={height}
        forceImageContain={true}
        containerAspectRatio={aspectRatio}
        resize={ImageResizeOptions.cover}
        fluid={true}
        alt=""
      />
    </div>
  );
};
